import { Spin } from "antd"
import styled from "styled-components"

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-primary);
  padding: var(--size-12) var(--size-8);
`

interface IProps extends React.ComponentPropsWithRef<"div"> {
  size?: number
}

const Loader: React.FC<IProps> = ({ size = 14, ...props }) => {
  return (
    <Container {...props}>
      <Spin />
    </Container>
  )
}

export default Loader
